import { useEffect, useState, useMemo } from "react";
import { Group, FormControl, Grid, Layout, Button, Icon, TGridRenderSchema } from "@/comn/components";
import { useForm, useGrid, TGridSchema, TFormSchema, usePopup, useModal, useResource, useFetch } from "@/comn/hooks";
import { api } from "@/comn";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Sample } from "@/comn/components/_";
import { read, utils } from "xlsx";

export const GuideEdoc = () => {
    return (
        <Sample>
            <Layout>
                <Layout direction="col">
                    <label htmlFor="intfId">인터페이스 ID</label>
                    <input type="text" id="intfId" className="input" />
                </Layout>
                <Layout direction="col">
                    <label htmlFor="intfCntx">인터페이스 Context</label>
                    <input type="text" id="intfCntx" className="input" />
                </Layout>
            </Layout>
            <Layout>
                <Layout direction="col">
                    <label htmlFor="intfFile">인터페이스 정의 파일</label>
                    <input type="file" id="intfFile" className="input" onChange={(e) => {}} />
                </Layout>
            </Layout>
        </Sample>
    );
};
